import { BehaviorSubject } from "rxjs";
import { EventEmitter } from "@angular/core";
import { HttpParams } from "@angular/common/http";
import { IFilter } from "../services/IFilter";
import { AuthService } from "../services/auth.service";

export class SubnetsFilter implements IFilter {
  anyChange:EventEmitter<any> = new EventEmitter<any>();

  constructor(private auth: AuthService) {
    this.clear();
  }

  companyIdChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get companyId():any {
    return this.companyIdChange.value;
  }
  set companyId(value:any) {
    this.companyIdChange.next(value);
    this.emitChange("companyId", value);
  }

  nameChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get name():any {
    return this.nameChange.value;
  }
  set name(value:any) {
    this.nameChange.next(value);
    this.emitChange("name", value);
  }

  vlanIdChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get vlanId():any {
    return this.vlanIdChange.value;
  }
  set vlanId(value:any) {
    this.vlanIdChange.next(value);
    this.emitChange("vlanId", value);
  }

  descriptionChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get description():any {
    return this.descriptionChange.value;
  }
  set description(value:any) {
    this.descriptionChange.next(value);
    this.emitChange("description", value);
  }

  networkChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get network():any {
    return this.networkChange.value;
  }
  set network(value:any) {
    this.networkChange.next(value);
    this.emitChange("network", value);
  }

  subnetChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get subnet():any {
    return this.subnetChange.value;
  }
  set subnet(value:any) {
    this.subnetChange.next(value);
    this.emitChange("subnet", value);
  }

  subnetMaskChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get subnetMask():any {
    return this.subnetMaskChange.value;
  }
  set subnetMask(value:any) {
    this.subnetMaskChange.next(value);
    this.emitChange("subnetMask", value);
  }

  startIPChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get startIP():any {
    return this.startIPChange.value;
  }
  set startIP(value:any) {
    this.startIPChange.next(value);
    this.emitChange("startIP", value);
  }

  endIPChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get endIP():any {
    return this.endIPChange.value;
  }
  set endIP(value:any) {
    this.endIPChange.next(value);
    this.emitChange("endIP", value);
  }

  gatewayChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get gateway():any {
    return this.gatewayChange.value;
  }
  set gateway(value:any) {
    this.gatewayChange.next(value);
    this.emitChange("gateway", value);
  }

  emitChange(prop:string, value:any):void {
    this.anyChange.emit({"prop": prop, "value": value});
  }

  getParams():HttpParams {
    let params:HttpParams = new HttpParams();

    if (this.companyId && this.companyId !== '') {
      params = params.set("companyId", this.companyId);
    }
    if (this.name && this.name !== '') {
      params = params.set("name", this.name);
    }
    if (this.vlanId && this.vlanId !== '') {
      params = params.set("vlanId", this.vlanId);
    }
    if (this.description && this.description !== '') {
      params = params.set("description", this.description);
    }
    if (this.network && this.network !== '') {
      params = params.set("network", this.network);
    }
    if (this.subnet && this.subnet !== '') {
      params = params.set("subnet", this.subnet);
    }
    if (this.subnetMask && this.subnetMask !== '') {
      params = params.set("subnetMask", this.subnetMask);
    }
    if (this.startIP && this.startIP !== '') {
      params = params.set("startIP", this.startIP);
    }
    if (this.endIP && this.endIP !== '') {
      params = params.set("endIP", this.endIP);
    }
    if (this.gateway && this.gateway !== '') {
      params = params.set("gateway", this.gateway);
    }

    return params;
  }

  setFilters(props: any): void {
    this.companyIdChange.next(props.companyId === undefined ? this.auth.getCompanyId() : props.companyId || undefined);
    this.nameChange.next(props.name || undefined);
    this.vlanIdChange.next(props.vlanId || undefined);
    this.descriptionChange.next(props.description || undefined);
    this.networkChange.next(props.network || undefined);
    this.subnetChange.next(props.subnet || undefined);
    this.subnetMaskChange.next(props.subnetMask || undefined);
    this.startIPChange.next(props.startIP || undefined);
    this.endIPChange.next(props.endIP || undefined);
    this.gatewayChange.next(props.gateway || undefined);
  }

  toObj() {
    let obj:any = {};
    
    obj.companyId = this.companyId;
    obj.name = this.name;
    obj.vlanId = this.vlanId;
    obj.description = this.description;
    obj.network = this.network;
    obj.subnet = this.subnet;
    obj.subnetMask = this.subnetMask;
    obj.startIP = this.startIP;
    obj.endIP = this.endIP;
    obj.gateway = this.gateway;
  
    return obj;
  }

  public clear():void {
    this.companyId = this.auth.getCompanyId();
    this.name = undefined;
    this.vlanId = undefined;
    this.description = undefined;
    this.network = undefined;
    this.subnet = undefined;
    this.subnetMask = undefined;
    this.startIP = undefined;
    this.endIP = undefined;
    this.gateway = undefined;
  }
}
